import { useEffect } from "react";
import Lenis from "lenis";
import "@/App.css";
import { Toaster } from "sonner";
import { Navbar } from "@/components/portfolio/Navbar";
import { Hero } from "@/components/portfolio/Hero";
import { About } from "@/components/portfolio/About";
import { FeaturedWork } from "@/components/portfolio/FeaturedWork";
import { Skills } from "@/components/portfolio/Skills";
import { Connect } from "@/components/portfolio/Connect";

function App() {
  useEffect(() => {
    const lenis = new Lenis({
      duration: 1.1,
      easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
      smoothWheel: true,
    });
    let raf;
    const loop = (time) => {
      lenis.raf(time);
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);
    return () => {
      cancelAnimationFrame(raf);
      lenis.destroy();
    };
  }, []);

  return (
    <div className="App bg-[#F6F3EE] text-[#1F2D3D] min-h-screen">
      <Toaster theme="light" position="bottom-right" richColors />
      <Navbar />
      <main>
        <Hero />
        <About />
        <FeaturedWork />
        <Skills />
        <Connect />
      </main>
    </div>
  );
}

export default App;
